<template>
	<div>
		<div class="row">
			<div v-for="col in cols" :class="`col-xs-12 col-sm-${col.size}`" v-bind:key="col.key">
				{{ data[col.key] }}
			</div>
		</div>
	</div>
</template>

<script>
export default {
	props: {
		data: {},
		cols: [],
	},
	mounted() {
		console.log("data", this.data);
		console.log("cols", this.cols);
	},
};
</script>
